import React, { Fragment, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Divider,
  Box,
  Button,
  Drawer,
  Hidden,
  List,
  ListItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import BusinessCenterRoundedIcon from '@material-ui/icons/BusinessCenterRounded';
import IndeterminateCheckBoxRoundedIcon from '@material-ui/icons/IndeterminateCheckBoxRounded';
import Icon from '@material-ui/core/Icon';
import InputIcon from '@material-ui/icons/Input';
import avatar from '../../../img/logo-gmi.png';

const admin = {
  avatar: avatar,
  name: 'GMI Aero'
};

const items = [
  {
    href: '/admin/dashboard',
    icon: DashboardRoundedIcon,
    title: 'Dashboard'
  },
  {
    href: '/admin/consoles',
    icon: BusinessCenterRoundedIcon,
    title: 'Consoles ICON 1'
  },
  {
    href: '/admin/consoles2',
    icon: IndeterminateCheckBoxRoundedIcon,
    title: 'Consoles ICON 2'
  },
  {
    href: '/admin/consolesedit',
    icon: IndeterminateCheckBoxRoundedIcon,
    title: 'Edit console'
  }
];

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    backgroundColor: 'var(--gmi-color)',
    width: 256
  },
  desktopDrawer: {
    backgroundColor: 'var(--gmi-color)',
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    border: 'white 1px solid',
    cursor: 'pointer',
    width: 100,
    height: 100
  },
  name: {
    marginTop: '15px',
    color: 'white'
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 8px',
    textTransform: 'none',
    width: '100%'
  },
  icon: {
    color: 'white',
    marginRight: theme.spacing(1)
  },
  title: {
    color: 'white',
    marginRight: 'auto'
  },
  active: {
    color: 'white',
    background: 'linear-gradient(270deg, #F0F6FF 0%, #71A5EB 0.01%, #113D78 96.34%)',
    '& $title': {
      fontWeight: theme.typography.fontWeightBold
    },
    '& $icon': {
      transform: 'scale(1.3)',
      color: 'white'
    }
  }
}));

const NavBarAdmin = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose === false) {
      onMobileClose();
    }
  }, [location.pathname, onMobileClose, openMobile]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          src={admin.avatar}
        />
        <Typography
          className={classes.name}
          variant="h6"
        >
          {admin.name}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map(item => {
            return (
              <ListItem
                className={classes.item}
                key={item.title}
                disableGutters
              >
                <Button
                  activeClassName={classes.active}
                  className={classes.button}
                  component={NavLink}
                  to={item.href}
                >
                  <item.icon
                    className={classes.icon}
                    size="20"
                  />
                  <span className={classes.title}>
                    {item.title}
                  </span>
                </Button>
              </ListItem>
            )
          })}
          <ListItem
            className={classes.item}
            disableGutters
          >
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={NavLink}
              to={'/admin/consoles3'}
            >
              <Icon
                className={classes.icon}
                size="20"
              >
                home_repair_service
              </Icon>
              <span className={classes.title}>
                {'Consoles ICON 3'}
              </span>
            </Button>
          </ListItem>
        </List>
      </Box>
      <Box flexGrow={1} />
      <Box
        p={2}
        m={2}
      >
        <List>
          <ListItem
            className={classes.item}
            disableGutters
          >
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={NavLink}
              to={'/login'}
            >
              <InputIcon
                className={classes.icon}
                size="20"
              />
              <span className={classes.title}>
                {'Logout'}
              </span>
            </Button>
          </ListItem>
        </List>
      </Box>
    </Box>
  );

  return (
    <Fragment>
      <Hidden mdUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBarAdmin.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBarAdmin.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBarAdmin;
